import { BACKEND_URL } from "../env";

export type RedeemMagicLinkResult = {
  redirectTo: string;
};

export async function redeemMagicLink(
  token: string
): Promise<RedeemMagicLinkResult> {
  const response = await fetch(`${BACKEND_URL}/magic-links/redeem`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    throw new Error("magic link redeem failed");
  }

  return (await response.json()) as RedeemMagicLinkResult;
}
